<template>
  <div>
    <form>
      <div class="form-group">
        <label for="username">Email</label>
        <input
          type="email"
          v-validate="'required|email'"
          name="email"
          :class="{
            input: true,
            'is-danger': errors.has('email'),
            'is-success': !errors.has('email')
          }"
          class="form-control form-control-lg"
          v-model="userCredentials.username"
          placeholder="Enter email"
          id="username"
          required
        />
        <span v-show="errors.has('email')" class="text-danger">Your email address may have been entered incorrectly, please enter a valid email</span>
      </div>
      <div class="form-group">
        <label for="password">Password</label>
        <input
          type="password"
          v-validate="'required|min:8'"
          name="password"
          :class="{
            input: true,
            'is-danger': errors.has('password'),
            'is-success': !errors.has('password')
          }"
          class="form-control form-control-lg"
          v-model="userCredentials.password"
          placeholder="Enter password"
          id="password"
          required
          autocomplete="off"
        />
        <span v-show="errors.has('password')" class="text-danger">{{ errors.first("password") }}</span>
      </div>
      <div class="form-group mt-21">
        <button type="submit" class="btn btn-primary btn-block" v-on:click.prevent="loginUser">
          Sign In
        </button>
      </div>
    </form>
    <div class="footer-links forgot-links">
      <router-link :to="{ name: 'forgotPassword' }">Forgot Password</router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "legacyLogin",
  data() {
    return {
      userCredentials: {
        username: "",
        password: ""
      }
    };
  },
  computed: {
    ...mapGetters(["user"])
  },
  methods: {
    ...mapActions(["userLogin", "setmultiFactorEnableFlag"]),
    async loginUser() {
      if (!this.errors.any()) {
        try {
          const userResponse = await this.userLogin(this.userCredentials);
          if (userResponse && userResponse.next === "TwoFARequest") {
            this.setmultiFactorEnableFlag(true);
            this.$emit("goToMFAScreen", userResponse);
          }
        } catch (error) {
          this.$toastr.error(error.message);
        }
      } else if (!this.userCredentials.username && !this.userCredentials.password) {
        this.$toastr.error("Please enter your credentials.");
      } else if (!this.userCredentials.username) {
        this.$toastr.error("Please provide your email, it is required");
      } else if (!this.userCredentials.password) {
        this.$toastr.error("Please provide your password, it is required");
      }
    }
  }
};
</script>
